/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateClientNameApiArg, UpdateClientNameData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateClientName: build.mutation<UpdateClientNameData, UpdateClientNameApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/clients/${queryArg.clientId}/name`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateClientNameApi };
export const { useUpdateClientNameMutation } = injectedRtkApi;
